// extracted by mini-css-extract-plugin
export default {"container":"aWJvPX","external":"bWJvPX","suggestBlock":"cWJvPX","openSuggestBlock":"dWJvPX","suggestTitle":"eWJvPX","suggestContainer":"fWJvPX"};